<script setup>
    import { Field } from 'vee-validate';

    defineProps({
        name: {
            type: String,
            required: true,
        },
    });
</script>

<template>
    <Field v-slot="{ field }" :name="name">
        <input type="hidden" v-bind="field" />
    </Field>
</template>
